export default __webpack_public_path__ + "images/logos/nordea.svg";